import React from 'react';
import { Pagetitle } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';
import BackToOverview from 'components/backToOverview/BackToOverview';
import UnsubscribeProgress from './UnsubscribeProgress';
import UnsubscribeInfoBox from './UnsubscribeInfoBox';

interface Props {
  isSuccessful?: boolean;
  doNotUnsubscribe?: boolean;
  viaNewsletter: boolean;
  newsletterId?: number;
  isTimeout?: boolean;
}

const UnsubscribeConfirmation = ({
  isSuccessful,
  doNotUnsubscribe,
  viaNewsletter,
  // INFO: Will be used for feedback component in the future, remove eslint-disabler when used
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  newsletterId,
  isTimeout,
}: Props) => {
  const { t } = useTranslation('newsletter');

  return (
    <div className="unsubcribeconfirmation richtext">
      <Pagetitle additionalClassNames="unsubscribeconfirmation__header">
        {t('unsubscribe_header')}
      </Pagetitle>
      {!viaNewsletter && <UnsubscribeProgress isSuccess={isSuccessful} />}
      <UnsubscribeInfoBox
        isSuccessful={isSuccessful}
        doNotUnsubscribe={doNotUnsubscribe}
        isTimeout={isTimeout}
      />
      <BackToOverview />

      {/* INFO: The feedback component will not be used yet. The decision for the integration will be part of V2. */}
      {/* {!doNotUnsubscribe && isSuccessful && (
        <UnsubscribeFeedbackForm
          id={viaNewsletter ? newsletterId : Number(searchParams.get('id'))}
        />
      )} */}
    </div>
  );
};

export default UnsubscribeConfirmation;
